interface DropURIResult {
    kind: "uri";
    value: string;
}

interface DropFileResult {
    kind: "file";
    value: readonly File[];
}

export type DropResult = DropURIResult | DropFileResult;

export async function extractDropContents(ev: React.DragEvent<HTMLElement>): Promise<DropResult | undefined> {
    const promiseResolver = new Promise<DropResult | undefined>(resolve => {
        if (ev.dataTransfer.items !== undefined) {
            // Use DataTransferItemList interface to access the file(s)
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                const item = ev.dataTransfer.items[i];
                if (item.kind === "file") {
                    const file = item.getAsFile();
                    if (file !== null) {
                        resolve({ kind: "file", value: [file] });
                        return;
                    }
                } else if (item.kind === "string" && item.type === "text/uri-list") {
                    item.getAsString(uri => resolve({ kind: "uri", value: uri }));
                    return;
                }
            }
        } else {
            // Use DataTransfer interface to access the file(s)
            resolve({ kind: "file", value: Array.from(ev.dataTransfer.files) });
            return;
        }
        resolve(undefined);
    });

    return promiseResolver;
}
